import { StoreModule } from '@ngrx/store';
import { SuperAdminHomeFeatureKey } from './superadmin-home-feature-key';
import { superAdminHomeReducer } from './superadmin-home.reducer';

export * from './superadmin-home-feature-key';
export * from './superadmin-home.actions';
export * from './superadmin-home.effects';
export * from './superadmin-home.reducer';
export * from './superadmin-Home.selectors';

export const SuperAdminHomeStoreModule = StoreModule.forFeature(
  SuperAdminHomeFeatureKey,
  superAdminHomeReducer
);
